// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"db2b72c0","183":"55a7c57a","233":"54d2d339","453":"3b4ea026","469":"b076893b","827":"55471002","997":"99bbb788"}[chunkId] + ".chunk.js";
};